import { ApiClient } from "@/services/apiClient";
import { MarketplaceItem_Schema } from "@/services/marketplace/item/marketplaceItemSchema";
import { MarketplaceItemNotFoundException, type MarketplaceItem, type MarketplaceItem_Api_CreationData, type MarketplaceItem_Api_UpdateData, type MarketplaceItemId } from "@/services/marketplace/item/marketplaceItemTypes";
import { handleAxiosError } from "@/utilities";
import type { AxiosResponse } from "axios";
import type { PriceNumeric } from "@/services/prices";

export const fetchMarketplaceItemById = async (id: MarketplaceItemId): Promise<MarketplaceItem> => {
  const url = "api-public/market-place/market-place-item/" + id;
  return ApiClient.getPublic<MarketplaceItem>(url)
    .then(({ data }) => MarketplaceItem_Schema.parse(data))
    .catch(
      handleAxiosError({
        404: () => {
          throw new MarketplaceItemNotFoundException();
        },
      })
    );
};

export const createMarketplaceItem = async (data: MarketplaceItem_Api_CreationData): Promise<MarketplaceItem> => {
  const url = "api/market-place/market-place-item";
  return ApiClient.post<MarketplaceItem>(url, {}, data).then(({ data }) => MarketplaceItem_Schema.parse(data));
};

export const updateMarketplaceItem = async (id: MarketplaceItemId, data: MarketplaceItem_Api_UpdateData): Promise<MarketplaceItem> => {
  const url = "api/market-place/market-place-item/" + id;
  return ApiClient.put<MarketplaceItem>(url, {}, data).then(({ data }) => MarketplaceItem_Schema.parse(data));
};

export const deleteMarketplaceItem = async (id: MarketplaceItemId): Promise<AxiosResponse> => {
  const url = "api/market-place/market-place-item/" + id;
  return ApiClient.delete(url);
};

export const adminWithdrawMarketplaceItem = async (id: MarketplaceItemId): Promise<AxiosResponse> => {
  const url = "api/market-place/market-place-item-unpublish/" + id;
  return ApiClient.post(url);
};

export const updateMarketplaceItemPrice = async (id: MarketplaceItemId, price: PriceNumeric): Promise<MarketplaceItem> => {
  const url = "api/market-place/market-place-item-price";
  return ApiClient.post<MarketplaceItem>(url, {}, { marketPlaceItemId: id, itemPrice: { priceAmountCents: price.price * 100, priceCurrency: price.currencyId } }).then(({ data }) => MarketplaceItem_Schema.parse(data));
};
